export const COURSES_ALL_DATA = 'COURSES_ALL_DATA'
export const COURSES_PARTICULAR_ID = 'COURSES_PARTICULAR_ID'
export const INSTRUCTORS_ALL_DATA = 'INSTRUCTORS_ALL_DATA'
export const CURRENT_USER_ALL_DATA = 'CURRENT_USER_ALL_DATA'
export const REGISTER_FOR_CLASS = 'REGISTER_FOR_CLASS'
export const MY_ALL_COURSES = 'MY_ALL_COURSES'